module.exports = __webpack_public_path__ + "static/media/male-doctor.474ae7bc.svg";